import * as R from "ramda";
const withFlatHierarchy = (dimension) => {
  const indexedValues = R.indexBy(
    R.prop("id"),
    R.propOr([], "values", dimension)
  );
  const grouped = R.pipe(
    R.propOr([], "values"),
    R.groupBy(
      R.pipe(
        R.prop("parent"),
        R.when(
          R.anyPass([R.isNil, R.pipe(R.flip(R.has)(indexedValues), R.not)]),
          R.always("root")
        )
      )
    )
  )(dimension);
  const reccur = (parents) => R.pipe(
    R.propOr([], R.last(parents)),
    R.map(
      R.pipe(
        R.assoc("parents", R.tail(parents)),
        (value) => R.prepend(value, reccur(R.append(R.prop("id", value), parents)))
      )
    )
  )(grouped);
  const leveledValues = reccur(["root"]);
  return R.assoc("values", R.flatten(leveledValues), dimension);
};
export {
  withFlatHierarchy
};
